import button from './button.js';
import container from './container.js';
import modal from './modal.js';

export default {
    button,
    container,
    modal,
};
